<template>
	<div class="profile-layout">
		<header-component type="profile" />
		<h1 class="profile-layout__title">{{ title }}</h1>
		<div v-if="email" class="profile-layout__user">
			<span class="profile-layout__user-icon">
				<svg-icon name="profile" :size="20" />
			</span>
			<span class="profile-layout__email">{{ email }}</span>
		</div>
		<slot />
		<slot name="footer" />
	</div>
</template>

<script setup lang="ts">
import HeaderComponent from '@/components/HeaderComponent.vue'
import SvgIcon from '@/components/SvgIcon.vue'

defineProps<{
	title: string
	email?: string
}>()
</script>

<style lang="scss" scoped>
.profile-layout {
	width: 100%;
	@include flex-column-center;
	&__title {
		font: var(--font-title);
		color: var(--text-primary);
		text-align: center;
		margin-bottom: 16px;
	}
	&__user {
		display: flex;
		align-items: center;
		width: 100%;
		margin-bottom: 12px;
	}
	&__user-icon {
		width: 32px;
		height: 32px;
		flex-shrink: 0;
		color: var(--text-brand);
		background-color: var(--background-brand-alpha);
		border-radius: var(--radius-sm);
		@include flex-center;
		margin-right: 8px;
		.svg-icon {
			width: 20px;
			height: 20px;
		}
	}
	&__email {
		font: var(--font-subtitle);
		color: var(--text-primary);
		overflow-wrap: anywhere;
	}
}
</style>
